import * as React from "react";
import { styled } from "@mui/material/styles";
import { Paper, InputBase, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

// Styled Input
const StyledInput = styled(InputBase)(({ theme }) => ({
  "& input::placeholder": {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    color: "#000000",
    opacity: 0.4,
  },
}));

// Styled Paper
const SearchPaper = styled(Paper)(({ theme }) => ({
  padding: "15px 18px",
  display: "flex",
  alignItems: "center",
  width: "100%",
  height: "50px",
  borderRadius: "10px",
  justifyContent: "space-between",
}));

export default function Search({
  getSearchedAudience,
  searchKey,
  setSearchKey,
  setPage,
}) {
  return (
    <SearchPaper component="form" elevation={0}>
      <StyledInput
        fullWidth
        placeholder="Search"
        value={searchKey}
        onChange={(e) => {
          setPage(1);
          setSearchKey(e.target.value);
        }}
        sx={{
          "&::placeholder": {
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "20px",
            color: "#000000",
            mixBlendMode: "normal",
            opacity: 0.4,
          },
        }}
      />
      <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
        <SearchIcon sx={{ color: "rgba(128, 128, 128, 0.7)" }} />
      </IconButton>
    </SearchPaper>
  );
}
